<script>
import Vue from 'vue';
import Base from '@backend/Base.vue';
import BOGen from '@helper/BOGen.js';
import Gen from '../helper/Gen';
// import BoConfig from '@config/BoConfig.js';

Vue.component("WorkingFacility",()=>import("@backend/WorkingFacility.vue"))

export default {
  extends: Base,
  data(){
    return {
      Name:"OffboardingInit",
      PageName: "Offboarding Initiation",
      ObjectName: "Offboarding Initiation",
      NoList: true,
      mrRequestFor: [],
      tab: "current",
      row: {aa:{},aal:{}},
      manager: {},
      emp: {},
      input: {mrf_id:"",ai_cwid:""},
      WFcurrent: {},
      mrValidation:{
        mrf_id: "required",
        ai_cwid: "required",
        ai_end_date: "required"
      }
    }
  },
  computed:{
    self(){ return this },
    mrf(){ return this.mrRequestFor.filter(x=>{ return x.mrf_id == this.input.mrf_id })[0] || this.mrRequestFor[0] },
  },
  mounted(){
    this.checkMenuOffboarding()
    this.setNameRoute();
    this.$set(this.$root, 'page', this)
    this.apiMrRequestFor()
    if(this.$route.params.id){
      this.refreshData()
    }
  },
  methods:{
    refreshData(){
      this.loadingOverlay = true
      var params = {cwid:this.input.ai_cwid,request_number:this.$route.params.id}
      BOGen.apirest("/WorkingFacility", params, (err, resp)=>{
        this.loadingOverlay = false
        if(err) return console.error(err);
        Object.keys(resp).forEach((k)=>{
          this[k] = resp[k]
        })
        if(this.WFcurrent.setParent) this.WFcurrent.setParent()
        // Encrypted
        this.emp.remarks = ""
        // Edited
        if(this.$route.params.id){
          this.input.ai_id = this.row.ai_id
          this.input.ai_cwid = this.row.ai_cwid
          this.input.mrf_id = this.row.ai_mrf_id
        }
      }, "POST")
    },
    apiMrRequestFor(){
      BOGen.apirest("/request-for-select", {type:'offboarding'}, (e,resp)=>{
        if(e) return console.error(e)
        this.mrRequestFor = resp.data
      })
    },
    checkMenuOffboarding(){
      const menu = this.user.al_access_menu

      if(menu.indexOf("Offboarding") < 0){
        return this.$router.push({name:"Dashboard"})
      }
    },
    resultDataEmployee(data) {      
      var items = [];
      data.data.forEach((x)=>{
        items.push({
          id: x.cwid,
          text: (x.cwid?x.cwid+" | ":"")+x.employeename+" "+(x.position?"("+x.position+")":""),
        })
      })
      return {results: items}
    },
    getManager(){
      BOGen.apirest("/get-manager", {cwid: this.input.ai_cwid}, (e,resp)=>{
        if(e) return console.error(e)
        
        if(resp.manager){
          this.manager = resp.manager
        } else {
          this.manager = {employeename: '-'}
        }
      })
    },
    submitForm(e){
      swal({
        title: "Are you sure to submit?",
        text:"",
        icon: "warning",
        buttons: ["No, Cancel!", "Yes, Sure!"],
        // dangerMode: true,
      }).then((ok) => {
        if(!ok) return;
        if(e.btnLoading()) return;
        if(this.Name=="OffboardingInit"){
          var params = Gen.clone(this.input)
          params.workingFacilitiesActive = this.WFcurrent.workingFacilitiesActive()
          params.filteredWorkingFacilitiesActive = this.WFcurrent.workingFacilitiesActive().filter(d => d.active).map(v => v.module)        

          params.ai_end_date = this.input.ai_end_date.split('-').reverse().join('-')
          BOGen.apirest("/"+this.Name, Object.assign(params), (err, resp)=>{
            e.btnUnloading()
            if(err) { 
              console.error(err)
              swal(err.json.message, "", "warning").then(()=>{                                
                $("body,html").animate({scrollTop:0}, 300)
              })

              return console.error(err)
            }

            swal("Data has been submitted", "", "success").then(()=>{
              this.$router.push({name:"Offboarding"})
              this.input = {}
              $("body,html").animate({scrollTop:0}, 300)
            })
          }, "POST")
        }
      })
    }
  },
  watch:{
    'input.mrf_id'(v){
      if(!this.input.ai_id){
        this.$set(this.input, 'ai_cwid', '');
        this.emp = {}
        this.input = {mrf_id:v}
      }
    },
    'input.ai_cwid'(v){
      if(!v) return;
      this.refreshData()
    },
  }
}
</script>

<template>
  <div class="container-fluid">
    <div class="row page-titles align-items-center">
      <div class="col-md-5">
        <h4 class="text-themecolor">{{PageName}}</h4>
      </div>
      <div class="col-md-7 tr">
        <div class="btn-group">
          <router-link :to="{name:'Offboarding'}" class="btn btn-outline-info" v-tooltip="'List '+ObjectName">
            <i class="fa fa-list"></i><span> List</span>
          </router-link>
          <router-link :to="{name:'OffboardingInit'}" class="btn btn-outline-success" v-tooltip="'Add '+ObjectName">
            <i class="fa fa-plus"></i><span> Add</span>
          </router-link>
        </div>
      </div>
    </div>

    <VForm @resp="submitForm" method="post">
      <div class="card">
        <div class="card-header bg-info">
          <h4 class="m-b-0 text-white">Authorization</h4>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-striped m-b-0">
              <tbody>
                <tr>
                  <td style="padding-left: 20px" width="25%">
                    <b>Request Date</b>
                    <p>{{ "now".dates("format2") }}</p>
                  </td>
                  <td width="30%">
                    <BoField name="mrf_id">
                      <b slot="label">{{ fields.mrf_id }} <span class="text-danger">*</span></b>
                      <Select2 name="mrf_id" :options="mrRequestFor" :object="['mrf_id','mrf_name']" v-model="input.mrf_id" v-bind="validation('mrf_id')" v-if="$route.name=='OffboardingInit'" :disabled="input.ai_id">
                        <option value="">-- Select Request For --</option>
                      </Select2>
                      <span v-else>{{row.request_for}}</span>
                    </BoField>
                  </td>
                  <td>
                    <BoField name="ai_cwid">
                      <b slot="label">{{ fields.ai_cwid }} <span class="text-danger">*</span></b>
                      <Select2Ajax :url="'/api/employees-select?havecwid=true&mrf_id='+input.mrf_id+'&msg_id='+user.emp.msg_id+'&isAdmin='+(user.emp.access_level==1?true:false)+'&user='+user.emp.cwid+'&onlyEmployee=true'" name="ai_cwid" v-model="input.ai_cwid" v-bind="validation('ai_cwid')" :resultData="resultDataEmployee" placeholder="-- Select Employee --" v-if="$route.name=='OffboardingInit'" :disabled="input.ai_id" @input="getManager"></Select2Ajax>
                      <span v-else>{{emp.employeename}}</span>
                    </BoField>
                  </td>
                </tr>
                <tr>
                  <td style="padding-left: 20px">
                    <b>IPIN</b>
                    <p>{{ emp.IPIN || "-" }}</p>
                  </td>
                  <td>
                    <b>CWID</b>
                    <p>{{ emp.cwid || "-" }}</p>
                  </td>
                  <td>
                    <b>Department</b>
                    <p>{{ emp.department || "-" }}</p>
                  </td>
                </tr>
                <tr>
                  <td style="padding-left: 20px"><b>Position</b>
                    <p>{{emp.position || '-'}}</p>
                  </td>
                  <td>
                    <b>Cost Center SAP</b>
                    <p>{{ emp.costcenter || "-" }}</p>
                  </td>
                  <td>
                    <b>Manager</b>
                    <p>{{ manager.employeename || "-" }}</p>
                  </td>
                </tr>
                <tr>
                  <td style="padding-left: 20px"><b>Direct Reporting Manager</b>
                    <p>{{emp.report_manager || '-'}}</p>
                  </td>
                  <td>
                    <BoField name="ai_end_date" mandatory>
                      <div class="input-group">
                        <DatePicker name="ai_end_date" v-model="input.ai_end_date" v-bind="validation('ai_end_date')"></DatePicker>	
                        <div class="input-group-append"><span class="input-group-text"><i class="icon-calender"></i></span></div>
                      </div>
                    </BoField>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card-body mt-4" style="padding-top:0px">
          <div class="row">
            <div class="col-sm-12 text-right">
              <button type="button" @click="back()" class="btn btn-default mr5">Cancel</button>
              <button type="submit" class="fcbtn btn btn-info btn-outline btn-1e btn-loading">Submit Initiation <i class="icon-arrow-right14 position-right"></i></button>
            </div>
          </div>
        </div>
      </div>
      <WorkingFacility v-if="emp.cwid" :parent="self" @init="comp=>WFcurrent=comp" hidden></WorkingFacility>
    </VForm>
  </div>
</template>